// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/EngineerResolutionChart.js
//
// Purpose:
// Engineer Resolution Performance Chart
//
// Click Engineer
// -> DashboardDataDrawer
//
// Uses:
// DashboardCard
// ======================================================================

import React from "react";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

import DashboardCard
  from "./DashboardCard";

export default function EngineerResolutionChart({

  data = [],

  onEngineerClick,

}) {

  function handleClick(row) {

    if (
      !row ||
      !onEngineerClick
    ) {
      return;
    }

    onEngineerClick(
      row.engineer
    );
  }

  return (

    <DashboardCard

      title="Engineer Resolution Performance"

      subtitle="Closed tickets by engineer"

      height={450}

    >

      <ResponsiveContainer
        width="100%"
        height="90%"
      >

        <BarChart
          data={data}
        >

          <CartesianGrid
            strokeDasharray="3 3"
          />

          <XAxis
            dataKey="engineer"
          />

          <YAxis />

          <Tooltip />

          <Bar
            dataKey="closed"

            fill="#10b981"

            radius={[
              6,
              6,
              0,
              0,
            ]}

            onClick={handleClick}
          />

        </BarChart>

      </ResponsiveContainer>

    </DashboardCard>

  );
}